import { render, staticRenderFns } from "./PatternSwatchGrid.vue?vue&type=template&id=fc2e79a0&scoped=true&"
import script from "./PatternSwatchGrid.vue?vue&type=script&lang=js&"
export * from "./PatternSwatchGrid.vue?vue&type=script&lang=js&"
import style0 from "./PatternSwatchGrid.vue?vue&type=style&index=0&id=fc2e79a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2e79a0",
  null
  
)

export default component.exports